export default {
  contracts: {
    activeContracts: 'Hợp đồng có hiệu lực',
    productsAndHours: 'Sản phẩm hỗ trợ và thời gian hỗ trợ còn lại',
    supported: 'Được hỗ trợ',
    notSupported: 'Không được hỗ trợ',
    contact: 'Người quản lý'
  },
  states: {
    OPEN: 'Đang mở',
    AWAITING_REPLY: 'Đợi phản hồi',
    CLOSED: 'Đã đóng',
    FEEDBACK_REQUIRED: 'Yêu cầu phản hồi',
    onlyRequired: 'Hiển thị thông tin yêu cầu',
    onlyWorkRequests: 'Chỉ hiển thị phê duyệt yêu cầu công việc'
  },
  common: {
    New: 'Mới',
    Open: 'Đang mở',
    Pending: 'Đang chờ',
    Closed: 'Đã đóng',
    create: 'Khởi tạo',
    cancel: 'Hủy',
    goBack: 'Trở về',
    close: 'Đóng',
    goToMain: 'Quay lại trang chủ'
  },
  property: {
    name: 'Tên cơ sở',
    allProperties: 'Tất cả cơ sở',
    selectProperty: 'Chọn cơ sở'
  },
  product: {
    name: 'Tên sản phẩm',
    allProducts: 'Tất cả sản phẩm',
    selectProduct: 'Chọn sản phẩm',
    goBack: 'Trở về',
    noProducts: 'Không có sản phẩm'
  },
  chart: {
    chooseMonth: 'Chọn tháng',
    noData: 'Không có dữ liệu'
  },
  navigation: {
    main: 'CHÍNH',
    interactions: 'YÊU CẦU',
    contracts: 'HỢP ĐỒNG',
    signOut: 'ĐĂNG XUẤT'
  },
  tickets: {
    createNewTitle: 'Khởi tạo yêu cầu',
    title: 'Chủ đề',
    noTickets: 'Không có yêu cầu tương ứng với bộ lọc',
    search: 'Tìm kiếm',
    createNew: 'Tạo mới',
    reopenOrDisagree: 'Không đồng ý',
    escalation: 'Chuyển cấp',
    reason: 'Lí do',
    reopen: 'Mở lại',
    escalate: 'Chuyển cấp',
    opinionTitle: 'Ý kiến của bạn rất quan trọng với chúng tôi!',
    opinionBody: 'Vui lòng đánh giá chất lượng dịch vụ của chúng tôi',
    time: 'Thời gian giải quyết',
    qualification: 'Trình độ chuyên môn',
    communication: 'Kỹ năng giao tiếp',
    sendFeedback: 'Gởi phản hồi',
    leaveFeedback: 'Để lại phản hồi',
    close: 'Đóng',
    alreadyHasFeedback: 'Yêu cầu đã có phản hồi',
    feedbackHasBeenSent: 'Phản hồi đã được gởi',
    ticketHasBeenReopened: 'Yêu cầu đã được mở lại',
    ticketHasBeenEscalated: 'Yêu cầu đã được chuyển cấp',
    comment: 'Bình luận',
    keyPlaceholder: 'Nhap thong diep',
    approve: 'Chấp thuận',
    reject: 'Từ chối',
    workRequestOnContractNotification:
      'Kính gửi {{fullName}},\n\nHiện tại, bạn có {{hoursInSupportContract}} giờ dịch vụ giá trị gia tăng được bao gồm trong hợp đồng hỗ trợ của bạn.\nVé {{workRequestId}} sẽ cần {{hoursRequested}} giờ để hoàn thành. \n\nXin vui lòng chấp thuận việc khấu trừ số giờ từ số dư cho nhiệm vụ trên.\nCảm ơn bạn\n\nTrân trọng,\n{{tác giả}}',
    workRequestChargeableNotification:
      'Kính gửi {{fullName}},\n\nCông việc này không được bao gồm trong dịch vụ hoặc được đảm bảo theo hợp đồng. Chúng tôi sẽ sẵn lòng lên lịch và hỗ trợ. Chúng tôi ước tính {{hoursRequested}} giờ để hoàn thành yêu cầu {{workRequestId}}.\n\nChi phí hoàn thành yêu cầu này sẽ là {{amount}}.\nƯu đãi này có hiệu lực trong vòng 7 ngày kể từ ngày phát hành. \nNếu thời gian thực tế vượt quá báo giá ban đầu thì một biểu mẫu yêu cầu bổ sung về số giờ làm thêm sẽ được gửi đến người yêu cầu để phê duyệt. Nếu thời gian ước tính ít hơn báo giá ban đầu, báo giá ban đầu sẽ bị hủy và báo giá sửa đổi sẽ được gửi đi.\n\nXin vui lòng phê duyệt công việc và khoản phí bổ sung.\n\nTrân trọng,\n{{tác giả}}',
    workRequestCommentRequired:
      'Vui lòng cung cấp lý do từ chối yêu cầu công việc.'
  },
  severity: {
    name: 'Mức độ nghiêm trọng',
    0: 'Bình thường',
    1: 'Cao',
    2: 'Quan trọng'
  },
  forms: {
    password: 'Mật khẩu',
    confirmPassword: 'Xác nhận mật khẩu',
    passwordsDoNotMatch: 'Mật khẩu xác nhận không trùng',
    updatePassword: 'Cập nhật mật khẩu',
    askRestore: 'Yêu cầu cập nhật lại mật khẩu',
    remember: 'Ghi nhớ tôi',
    restorePassword: 'Khôi phục mật khẩu',
    signIn: 'Đăng nhập'
  },
  transactions: {
    date: 'Ngày',
    type: 'Loại',
    comment: 'Ý kiến',
    status: 'Trạng thái',
    subject: 'Yêu cầu công việc',
    name: 'Danh sách giao dịch',
    hours: 'Số giờ',
    viewTransactions: 'Xem giao dịch',
    types: {
      WORK_REQUEST: 'Yêu cầu công việc',
      CONTRACT_ACTIVATION: 'Kích hoạt hợp đồng',
      CONTRACT_EXPIRATION: 'Hết hạn hợp đồng',
      MANUAL_ADJUST_ADD: 'Điều chỉnh thủ công – Thêm',
      MANUAL_ADJUST_DEDUCT: 'Điều chỉnh thủ công – giảm',
      TRANSFER_PROPERTY: 'Chuyển nhượng cơ sở',
      TRANSFER_PRODUCT: 'Chuyển nhượng sản phẩm'
    }
  },
  transactionDetail: {
    name: 'Chi tiết giao dịch',
    num: 'Số',
    insertTime: 'Ngày khởi tạo',
    requestorName: 'Người yêu cầu',
    subject: 'Chủ đề',
    status: 'Trạng thái',
    acceptTime: 'Ngày chấp nhận',
    cancelTime: 'Ngày hủy',
    hours: 'Số giờ',
    hourType: 'Loại giờ',
    workText: 'Mô tả công việc',
    plannedDate: 'Ngày dự kiến'
  },
  statuses: {
    Approved: 'Đã chấp nhận',
    Pending: 'Đang chờ xử lý',
    Cancelled: 'Đã hủy'
  },
  hoursTypes: {
    'Included in contract': 'Bao gồm trong hợp đồng',
    'Installation hours': 'Số giờ cài đặt',
    'Preventative visit': 'Chuyến thăm Phòng ngừa sự cố',
    Chargeable: 'Có tính phí'
  },
  errors: {
    unknown: 'Lỗi không xác định',
    1000: 'Yêu cầu bị lỗi',
    1001: 'Yêu cầu bị lỗi',
    1: 'Sai thông tin đăng nhập hoặc mật khẩu',
    2: 'Phiên làm việc hết hạn',
    3: 'Cơ sở không xác định',
    4: 'Sản phẩm không xác định',
    7: 'Tương tác không xác định',
    8: 'Tương tác đã được đóng',
    11: 'Vi phạm quyền truy cập',
    12: 'Yêu cầu công việc không xác định'
  }
}
